import { FC } from 'react';
import { Box, Typography, Fade, Paper } from '@mui/material';

import { isSafeCssUrl } from '@cvt/helpers/validation';


interface Props {
  question: Feedback.Question;
  isFront?: boolean;
  backgroundImage?: string;
}

export const FeedbackQuestionCard: FC<Props> = ({ question, isFront = true, backgroundImage }) => {
  const candidate = question.image || backgroundImage;
  const image = isSafeCssUrl(candidate) ? candidate : undefined;
  return (
    <Fade in>
      <Box
        position="relative"
        variant="elevation"
        elevation={isFront ? 2 : 0}
        component={Paper}
        width="100%"
        height="100%"
        overflow="hidden"
        sx={{
          backgroundImage: image
            ? `url(${image})`
            : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <Fade in={isFront}>
          <Box
            position="absolute"
            width="100%"
            height="100%"
            top={0}
            left={0}
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{ zIndex: 2 }}
            p={3}
          >
            <Box className="speech-bubble arrow">
              <Typography
                variant="body1"
                align="center"
                fontSize={24}
                sx={{ transform: 'rotate(2deg) rotateY(-15deg)' }}
              >
                {question.content}
              </Typography>
            </Box>
          </Box>
        </Fade>
      </Box>
    </Fade>
  );
};
